import * as React from "react";
import type { SVGProps } from "react";
const SvgProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g stroke="#000" strokeWidth={2} opacity={0.9}>
      <path d="M18 12a6 6 0 0 1-5.004 5.918c-.545.09-.996-.366-.996-.918V7c0-.552.451-1.009.996-.918A6 6 0 0 1 18 12Z" />
      <path
        d="M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgProgress;
